import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import useGlobalSidebarStore from "stores/useGlobalSidebarStore";

// Record and settings routes give their width to their own rail, so the global
// rail collapses to icons under them and reopens when the user leaves for a
// non-record route.
export function CollapsedSidebarLayout() {
  useEffect(() => {
    const { setOpen } = useGlobalSidebarStore.getState();
    setOpen(false);
    return () => setOpen(true);
  }, []);

  return <Outlet />;
}
